// extracted by mini-css-extract-plugin
export default {"wrapper":"Registration_wrapper__FzD6l","formInput":"Registration_formInput__GnfIz","submitButton":"Registration_submitButton__z9TLj"};